export type VoiceProvider = 'jambonz' | 'twilio';

export interface ProviderEndpoints {
    TOKEN_URL: string;
    OUTBOUND_REQUEST_URL: string;
    CONFERENCE_HOLD_URL: string;
    CALL_TRANSFER_URL: string;
    CREATE_CALL_URL: string;
}

export interface VoiceDevice {
    status(): VoiceDeviceStatus;
    connect(params?: any): Promise<VoiceConnection>;
    setup(token: string, options?: any): any;
    terminate(): void;
}

export interface VoiceConnection {
    status(): VoiceConnectionStatus;
    isMuted(): boolean;
    disconnect(): void;
    mute(mute: boolean): void;
}

export enum VoiceConnectionStatus {
    Closed = 'closed',
    Connecting = 'connecting',
    Open = 'open',
    Pending = 'pending',
    Reconnecting = 'reconnecting',
    Ringing = 'ringing',
}

export enum VoiceDeviceStatus {
    Busy = 'busy',
    Offline = 'offline',
    Ready = 'ready',
}

export interface TokenResponse {
    token: string;
    iceServers: any[];
}

export interface ConferenceOnHoldResponse {
    result: boolean;
}

export interface Call {
    conferenceId: string;
    connection: VoiceConnection;
    onHold?: boolean;
}

export type CallStatus =
    | {
          status: VoiceDeviceStatus.Busy;
          ticketId: string;
      }
    | {
          status: VoiceDeviceStatus.Offline | VoiceDeviceStatus.Ready;
      };
export interface StunTurnConfiguration {
  url: string | string[],
  urls: string | string[],
  credential: string,
  username: string
}
